// extracted by mini-css-extract-plugin
export default {"actions":"ProjectSummary_actions__tjMoq","projectSummary":"ProjectSummary_projectSummary__agodw","warningSubtitle":"ProjectSummary_warningSubtitle__p0WOj"};